export enum featureFlagKeys {
	AccountBalance = '_checkout__account_balance_countries',
	BestSellerTag = 'show_pdp_tag_bestseller',
	SlimCatalog = 'slim_catalog',
	Chatbot = 'chatbot_toggle',
	CIAM = 'all_ciam',
	CookiesBanner = 'cookies_banner',
	CountryLanguage = 'all_country_language',
	Dam = 'dam',
	Discover = 'rollout_discover_by_mango',
	EditorialsSS25KaiaSecondphase = 'editorials_SS25_kaia_secondphase',
	EditorialsSS25KaiaNoCapsule = 'editorials_SS25_kaia_nocapsule',
	EnableDigitalReturns = 'enable_digital_returns',
	GenesisGiftVoucher = 'gift_voucher_genesis',
	GenesisPdp = 'pdp_genesis_activation',
	GenesisServerCache = 'genesis_server_cache',
	Header_black_ribbon = 'header_black_ribbon',
	HomeA11yHiddenLink = 'homes_a11y_hidden_link',
	LabelsTranslations = 'labels_translations',
	NewSearch = 'new_search',
	NewsletterConfiguration = 'newsletter_configuration',
	NonCriticalFeatures = 'non-critical_features',
	OmnibusExceptionCountries = 'price_omnibus_countries',
	OrderCancellation = 'mypurchases_cancel_order',
	PageForYou = 'page_for_you',
	PaymentStoredCards = 'payments_stored_cards',
	PlpBannersVasava = '_plp__banners__vasava_active',
	PrivacyPolicyConfiguration = 'privacy_policy_configuration',
	PrivacyPolicyRequestForm = 'privacy_policy_request_form',
	ProductCardOverlayLabel = 'productcard_overlay_label',
	ProductCarousel = 'shopping_cart_product_carousel',
	PromoBanner = 'promo_countdown',
	PurchaseEventInBack = '_checkout__purchase_event_in_back',
	ReturnHasCost = 'return_has_cost_since_date',
	ReturnsDisableDroppointMethod = 'returns_disable_droppoint_method',
	ReturnsFeedback = 'enable_returns_feedback',
	SecondReturnsBlock = 'block_second_returns',
	ShoppingCartRecommendationXselling = 'shopping_cart_recommendation_xselling',
	ShowDiscount = 'price_show_discount',
	ShowSavedPrice = 'cart_show_saved_price',
	PaymentEnablePaymentMethod = 'payment_enable_payment_method',
	MyPurchasesReturns = 'mypurchases_returns',
	ShoppingCartConfig = 'shopping_cart_config',
	Varnish = 'varnish',
	ScheduledHomePickup = 'scheduled_home_pickup',
}

export type NonCriticalFeaturesVariables = {
	favorites: boolean
	multiaddress: boolean
	my_purchases: boolean
	order_status_banner: boolean
	personalization_cart: boolean
	personalization_pdp: boolean
	personalization_plp: boolean
	personalization_search: boolean
}
